import { render } from "./DatasetSegmentsItemReadOnly.vue?vue&type=template&id=6f546e26"
import script from "./DatasetSegmentsItemReadOnly.vue?vue&type=script&lang=js"
export * from "./DatasetSegmentsItemReadOnly.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__